import React, { useEffect }  from "react"
import { Link } from 'gatsby'
import styled from 'styled-components'
import SmallArrow from '../../svgs/small-arrow.svg'
import DataTypes from '../../svgs/data-types.svg'
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"

const DataDesignDelivery = () => {
    useEffect(() => {
        if (typeof window !== `undefined`) {
            gsap.registerPlugin(ScrollTrigger)
            gsap.core.globals('ScrollTrigger', ScrollTrigger)
        }
        ScrollTrigger.matchMedia({
            "(min-width: 1201px)": function() {
                // Animate title
                let tlAiTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#section_three_animate",
                        start: 'top 80%',
                        end: 'top 80%',
                        id: 'section_three_title',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlAiTwo.to('.dm-header', { duration: .1, opacity: '1' })
                tlAiTwo.to('.dm-header', { maxHeight: '210px', maxWidth: '928px', padding: '50px 55px', border: '10px solid #C44C4A' })
                // Animate in content
                let tlTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#section_three_animate",
                        start: '400px 80%',
                        end: '400px 80%',
                        id: 'section_three_content',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlTwo.to('.dm-content', { duration: .3, opacity: '1', top: '0px' }, 0.5)
                tlTwo.to('.sthree-graphic', { duration: .3, opacity: '1', top: '0px' }, 1)
            },
            "(max-width: 1200px)": function() {
                let dmMobileOne = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#dm_mobile_one",
                        start: 'top 90%',
                        end: 'top 90%',
                        id: 'dm_mobile_one',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                dmMobileOne.to('.dm-header', { duration: .5, opacity: '1', top: '0' })
                let dmMobileThree = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#dm_mobile_three",
                        start: 'top 90%',
                        end: 'top 90%',
                        id: 'dm_mobile_three',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                dmMobileThree.to('.dm-content', { duration: .5, opacity: '1', top: '0' }, 0.5)
                dmMobileThree.to('.sthree-graphic', { duration: .5, opacity: '1', top: '0' }, 1)
            }
        });
    }, []);

    const data = useStaticQuery(graphql`
        query {
            hahn3dImage: file(relativePath: { eq: "Hahn-Flyweel.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 700
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
        }
    `)


    return(
        <MainSection id="section_three_animate">
            <div class="dm-header-box" id="dm_mobile_one">
                <div class="dm-header">
                    <h2>Data, Design, Delivery</h2>
                </div>
            </div>
            <div class="bottom-row">
                <div class="left-col">
                    <div class="dm-content"  id="dm_mobile_three">
                        <p>You see today’s challenges. We’ll show you tomorrow’s potential with Hahn’s 3D approach</p>
                        <Link to="/approach/">Learn More <SmallArrow/></Link>
                    </div>
                </div>
                <div class="right-col">
                    <GatsbyImage 
                        className={"hahn-3d-image sthree-graphic"}
                        image={data.hahn3dImage.childImageSharp.gatsbyImageData}
                        alt={"Hahn.Agency Hahn 3-D Approach"}
                    />
                </div>
            </div>
        </MainSection>
    );

}

const MainSection = styled.section`
    max-width: 1310px;
    width: 100%;
    margin: 100px auto;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    overflow: hidden;
    .dm-header-box {
        height: 210px;
        width: 928px;
    }
    .dm-header {
        border: 25px solid #C44C4A;
        padding: 0;
        max-height: 0;
        max-width: 0;
        overflow: hidden;
        opacity: 0;
        position: relative;
        h2 {
            font-family: "Nobel",sans-serif;
            font-size: 80px;
            line-height: 1.1;
            font-weight: 700;
            color: #2b2520;
            margin-top: 0;
            margin-bottom: 0px;
            width: 768px;
        }
        p {
            font-family: "Work Sans";
            font-size: 36px;
            line-height: 50px;
            font-weight: 400;
            color: #777C7C;
            margin-top: 0;
            margin-bottom: 0;
        }
    }
    .border-bottom {
        height: 23px;
        width: 100%;
        background-color: #eaeaea;
        margin-top: 35px;
    }
    .bottom-row {
        display: flex;
        .left-col {
            width: 690px;
            .dm-content {
                margin-top: 100px;
                margin-bottom: 90px;
                padding-left: 70px;
                max-width: 631px;
                position: relative;
                opacity: 0;
                top: 20px;
                h3 {
                    font-family: "Work Sans";
                    font-size: 30px;
                    line-height: 36px;
                    font-weight: 400;
                    color: #2b2520;
                    margin-top: 0;
                    margin-bottom: 10px;
                }
                p {
                    font-family: "Work Sans";
                    font-size: 24px;
                    line-height: 2;
                    font-weight: 400;
                    color: #777c7c;
                    margin-top: 0;
                    margin-bottom: 0px;
                }
                a {
                    font-family: "Work Sans";
                    font-size: 20px;
                    line-height: 24px;
                    font-weight: 700;
                    color: #2b2520;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    text-decoration: none;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    transition-duration: .3s;
                    svg {
                        width: 24px;
                        margin-left: 10px;
                        transition: all .3s cubic-bezier(.77,0,.175,1);
                    }
                    &:hover {
                        color: #C44C4A !important;
                        svg {
                            transform: translateX(10px);
                        }
                    }
                }
            }
        }
        .right-col {
            width: 570px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
            padding-top: 90px;
            .sthree-graphic {
                opacity: 0;
                top: 20px;
                position: relative;
            }
        }
    }
    @media(max-width:1200px) {
        .dm-header-box {
            height: auto;
            width: auto;
        } 
        .dm-header {
            border: 10px solid #C44C4A !important;
            padding: 35px !important;
            max-height: 100% !important;
            max-width: 100% !important;
            overflow: hidden;
            top: 40px;
            h2 {
                font-size: 80px;
                line-height: 1.2;
                margin-bottom: 0px;
            }
            p {
                font-size: 28px;
                line-height: 1.2;
            }
        }
        .bottom-row {
            width: 100%;
            .left-col {
                width: 55%;
                .dm-content {
                    padding-left: 45px;
                }
            }
            .right-col {
                width: 45%;
            }
        }
    }
    @media(max-width: 1000px) {
        flex-wrap: wrap;
        max-width: 700px;
        .dm-header-box {
            width: 100%;
        } 
        .dm-header {
            h2 {
                font-size: 44px;
            }
            p {
                font-size: 20px;
            }
        }
        .bottom-row {
            flex-wrap: wrap;
            .left-col {
                width: 100%;
                .dm-content {
                    margin: 0 auto;
                    margin-top: 60px;
                    margin-bottom: 40px;
                    padding-left: 0;
                    max-width: 520px;
                }
            }
            .right-col {
                width: 100%;
                padding-top: 0;
                .sthree-graphic {
                    max-width: 520px;
                    width: 100%;
                    margin: 0 auto;
                }
            }
        }
    }
    @media(max-width:767px) {
        max-width: 500px;
        width: 100%;
        overflow: hidden;
        margin: 50px auto;
        .dm-header {
            padding: 20px !important;
            border: 5px solid #C44C4A !important;
            h2 {
                font-size: 32px;
                width: 100%;
            }
        }
        .border-bottom {
            display: none;
        }
        .bottom-row {
            .left-col {
                .dm-content {
                    margin-top: 40px;
                    h3 {
                        font-size: 24px;
                        line-height: 1.2;
                    }
                    p {
                        font-size: 16px;
                        line-height: 1.6;
                    }
                    a {
                        font-size: 18px;
                    }
                }
            }
        }
    }
`

export default DataDesignDelivery